import { AppBar, Toolbar, Typography } from "@mui/material";
import React from "react";
import SignInButton from "../Buttons/SignInButton";
import routes from "../../routes/routes";
import Button from "@mui/material/Button";
import { useHistory } from "react-router-dom";

const Navbar = (props) => {
    const history = useHistory();

  const handleClick = (route) => {
    console.log(`Navigating to ${route}`);
    history.push(route);
  };
  return (
    <AppBar position="fixed" color="primary">
      <Toolbar style={{width: "100vw"}}>
        <Typography
          variant="h6"
          component="div"
          style={{ paddingLeft: "20px", marginRight: "30px" }}
        >
          LiquidX
        </Typography>
        {routes.map((r, i) => (
          <Button
            key={i}
            onClick={() => handleClick(r.path)}
            sx={{ color: "white"}}
          >
            {r.label}
          </Button>
        ))}
        <div style={{ pull: "right", display: "block" }}>
          <SignInButton RenderAs="NavLink"></SignInButton>
        </div>
      </Toolbar>
    </AppBar>
  );
};
export default Navbar;
